module.exports = __webpack_public_path__ + "static/media/fwb-image.fbd2e64d.jpeg";